import { useEffect } from "react";

export const customColors = {
    CUSTOMPRIMARYCOLOR: "--custom-primary-color",
    CUSTOMPRIMARYCONTRASTCOLOR: "--custom-primary-contrast-color",
    CUSTOMPRIMARYHOVERCOLOR: "--custom-primary-hover-color",
    CUSTOMSECONDARYCOLOR: "--custom-secondary-color",
    CUSTOMSECONDARYCONTRASTCOLOR: "--custom-secondary-contrast-color",
    CUSTOMSECONDARYHOVERCOLOR: "--custom-secondary-hover-color",
    CUSTOMLOGINCOLOR: "--custom-login-color",
    CUSTOMLOGINCONTRASTCOLOR: "--custom-login-contrast-color",
};

export const useCustomColors = (
    target: HTMLElement,
    colors: {
        customPrimaryColor: string;
        customPrimaryContrastColor: string;
        customPrimaryHoverColor: string;
        customSecondaryColor: string;
        customSecondaryContrastColor: string;
        customSecondaryHoverColor: string;
        customLoginColor: string;
        customLoginContrastColor: string;
    }
) => {
    const targetExists = !!target;

    useEffect(() => {
        if (!targetExists) {
            return;
        }

        // Change the color variables if custom colors exists. Otherwise the r360 color variables will remain default
        if (colors.customPrimaryColor) {
            target.style.setProperty(customColors.CUSTOMPRIMARYCOLOR, colors.customPrimaryColor);
        }

        if (colors.customPrimaryHoverColor) {
            target.style.setProperty(customColors.CUSTOMPRIMARYHOVERCOLOR, colors.customPrimaryHoverColor);
        }

        if (colors.customPrimaryContrastColor) {
            target.style.setProperty(customColors.CUSTOMPRIMARYCONTRASTCOLOR, colors.customPrimaryContrastColor);
        }

        if (colors.customSecondaryColor) {
            target.style.setProperty(customColors.CUSTOMSECONDARYCOLOR, colors.customSecondaryColor);
        }

        if (colors.customSecondaryContrastColor) {
            target.style.setProperty(customColors.CUSTOMSECONDARYCONTRASTCOLOR, colors.customSecondaryContrastColor);
        }

        if (colors.customSecondaryHoverColor) {
            target.style.setProperty(customColors.CUSTOMSECONDARYHOVERCOLOR, colors.customSecondaryHoverColor);
        }

        if (colors.customLoginColor) {
            target.style.setProperty(customColors.CUSTOMLOGINCOLOR, colors.customLoginColor);
        }

        if (colors.customLoginContrastColor) {
            target.style.setProperty(customColors.CUSTOMLOGINCONTRASTCOLOR, colors.customLoginContrastColor);
        }

        // eslint-disable-next-line
    }, [
        target,
        colors.customPrimaryColor,
        colors.customPrimaryHoverColor,
        colors.customPrimaryContrastColor,
        colors.customSecondaryColor,
        colors.customSecondaryContrastColor,
        colors.customSecondaryHoverColor,
    ]);
};
